const camelToSnake = (str) =>
  str.replace(/\s+/g, "_").replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();

export const exportRequestsToCSV = (requests, getMemberInfo, getTypeName) => {
  const headers = [
    "Request ID",
    "Title",
    "Description",
    "Type",
    "Material Price",
    "Labor Price",
    "Total",
    "Member Number",
    "Member Name",
    "Address",
    "Membership Type",
    "Started At",
    "Closed At",
    "Closed By",
  ];

  const rows = requests.map((req) => {
    const member = getMemberInfo(req.member_number);

    return {
      request_id: req.id,
      title: req.title,
      description: req.description,
      type: getTypeName(req),
      material_price: req.price ?? 0,
      labor_price: req.labor_price ?? 0,
      total: (parseFloat(req.price ?? 0) + parseFloat(req.labor_price ?? 0)).toFixed(2),
      member_number: req.member_number,
      member_name: member ? `${member.FirstName} ${member.LastName}` : "",
      address: member?.FullAddress || "",
      membership_type: member?.ClubMembershipTypeCode || "",
      started_at: new Date(req.started_at).toLocaleDateString(),
      closed_at: new Date(req.closed_at).toLocaleDateString(),
      closed_by: req.closed_by,
    };
  });

  const csvContent = [
    headers.join(","), // header row
    ...rows.map((row) =>
      headers
        .map((header) =>
          `"${(row[camelToSnake(header)] ?? "").toString().replace(/"/g, '""')}"`
        )
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "billable_requests.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
